import { oids } from "../lib/oids";
import { call } from "../lib/jsonrpc";

export const networkDeviceCiscoSpectrumEntryStart = (id, entryId) => {
  return call('networkDeviceSnmpSet', { id, oid: oids.ccsSpectrumRequestOperation + '.' + entryId, value: 1, type: 2 });
}

export default networkDeviceCiscoSpectrumEntryStart;